import RadioTile from '@liquidweb-dev/undercurrent/RadioTile';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';

interface BackupOption {
	label: string;
	value?: string;
	icon?: React.ReactNode;
	description: string;
	checked?: boolean;
}

const BackupTile = ({
	label,
	value,
	description,
	icon,
	checked = false,
	...rest
}: BackupOption & React.ComponentProps<typeof RadioTile>) => (
	<RadioTile key={value} value={value} checked={checked} {...rest}>
		<Stack gap={100}>
			<Stack direction="row" alignItems="center" gap={100}>
				{icon}
				<Typography variant="title-xs" fontWeight={500}>
					{label}
				</Typography>
			</Stack>
			<Typography
				variant="body-sm"
				sx={({ vars }) => ({ color: vars.palette.uc.text.weak })}
			>
				{description}
			</Typography>
		</Stack>
	</RadioTile>
);

export default BackupTile;
